import React from 'react'
import * as styles from './style'

// Helpers
import { renderRichText } from '../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'

// Components
import GlobalContainer from '../globalContainer'
import Typography from '../typography'

const ParagraphBlock = (props: any) => {
  if (props.data) {
    let headline: string = '',
      body: any,
      topPadding: string = 'None',
      bottomPadding: string = 'Large',
      orangeDivider: boolean = false,
      finePrint: any = '',
      quoteBlockTheme: string = 'Grey',
      centerAlignment: boolean = false

    if (props.data.headline) headline = props.data.headline
    if (props.data.body) body = props.data.body
    if (props.data.topPadding) topPadding = props.data.topPadding
    if (props.data.bottomPadding) bottomPadding = props.data.bottomPadding
    if (props.data.orangeDivider !== null) orangeDivider = props.data.orangeDivider
    if (props.data.finePrint) finePrint = props.data.finePrint
    if (props.data.theme) quoteBlockTheme = props.data.theme
    if (props.data.centerAlignment) centerAlignment = true
    return (
      <styles.blockContainer
        orangeDivider={orangeDivider}
        topPadding={topPadding}
        bottomPadding={bottomPadding}
        quoteBlockTheme={quoteBlockTheme}
        centerAlignment={centerAlignment}
        data-cy="ParagraphBlock">
        <GlobalContainer className="ParagraphBlock__Container">
          {headline && (
            <div className="paragrapghBlock__Title_container">
              <styles.blockTitle type="header2" className="paragrapghBlock__Title">
                {formatInlineCode(headline)}
              </styles.blockTitle>
            </div>
          )}
          {body && <div className="ParagraphBlock__Body">{renderRichText(body)}</div>}
          {finePrint && <Typography type="finePrint">{renderRichText(finePrint)}</Typography>}
        </GlobalContainer>
      </styles.blockContainer>
    )
  }
  return null
}

export default ParagraphBlock
